import React, { useEffect, useMemo, useState } from 'react';
import { useAppSettings, useProfileInterests, useSpringBigStore } from '@springbig/shared';
import ProfileHeader, { ProfileHeaderSkeleton } from './components/ProfileHeader';
import ProfileInterest from './components/ProfileInterest';
import { useAuthorization } from '~/hooks/auth';
import { useLocation } from 'react-router';
import { Section } from '~/shared/Theme';

const ProfileScreen = () => {

    const { state } = useLocation();

    const {
        interest,
        updateIsLoading,
        memberIsLoading,
        handleInterest
    } = useProfileInterests();

    const { member } = useSpringBigStore();

    const { isLoadingAuth } = useAuthorization();

    const showHeaderSkeleton = useMemo(() => ((!(state && state?.isInterestScreen) && memberIsLoading) || isLoadingAuth || member === undefined), [state, state?.isInterestScreen, memberIsLoading, isLoadingAuth, member]);
    const [isImageLoading, setIsImageLoading] = useState(true);
    const [profilePictureUri, setProfilePictureUri] = useState<string>();

    useEffect(() => {

        if (member && member.use_custom_profile_picture && member.profile_picture) {
            setProfilePictureUri(member.profile_picture);
        }
        else {
            setProfilePictureUri('');
        }
    }, [member]);

    return (
        <Section>
            {
                showHeaderSkeleton ?
                    <ProfileHeaderSkeleton />
                    :
                    <ProfileHeader member={member} isImageLoading={isImageLoading} setIsImageLoading={setIsImageLoading} profilePictureUri={profilePictureUri} />
            }
            { interest && interest?.length > 0 &&
                <ProfileInterest
                    handleInterest={handleInterest}
                    interest={interest}
                    updateIsLoading={updateIsLoading}
                />
            }
        </Section>
    );
};

export default ProfileScreen;
